import React from "react";

import { getApiBaseUrl, getApiEnvLabel, isApiEnvSwitchEnabled } from "../../api/apiEnv";
import ApiEnvSelector from "../../components/common/ApiEnvSelector";

const ApiEnvSettingsPage = () => {
  if (!isApiEnvSwitchEnabled()) {
    return (
      <section className="admin-page">
        <h2 className="section-title">API 환경</h2>
        <p className="api-env-page__desc">
          개발계 URL(`REACT_APP_DEV_API_BASE_URL`)이 설정되지 않아 전환 기능을 사용할 수 없습니다.
        </p>
        <p className="api-env-page__current">
          현재 연결: {getApiEnvLabel()} · {getApiBaseUrl()}
        </p>
      </section>
    );
  }

  return (
    <section className="admin-page api-env-page">
      <div className="api-env-page__header">
        <h2 className="section-title">API 환경</h2>
        <p className="api-env-page__desc">
          관리자 화면이 호출할 API 서버를 선택합니다. 환경을 바꾸면 로그인 세션이 초기화됩니다.
        </p>
        <p className="api-env-page__current">
          현재 연결: <strong>{getApiEnvLabel()}</strong> · {getApiBaseUrl()}
        </p>
      </div>

      <ApiEnvSelector variant="panel" />
    </section>
  );
};

export default ApiEnvSettingsPage;
